import MaritalStatus from '@/models/Shared/MaritalStatus';

export default class MaritalStatusViewModel {
    name: string;
    value: MaritalStatus;

    public constructor(name: string, value: MaritalStatus) {
        this.name = name;
        this.value = value;
    }
}